import React from 'react';
import { useSelector } from 'react-redux';

import SignUpSocialMedia from '@/components/SignUpSocialMedia/SignUpSocialMedia';
import { useSignInContext } from '@/contexts/SignInContext';
import { useSocialSignupForm } from '@/hooks/useSocialSignupForm';
import { selectSettings } from '@/reducers/common/selectors';

interface SocialSignupFlowProps {
  resourcesData: Record<string, any>;
  onSubmit: (_formData: any) => Promise<void>;
  initialFormState?: any;
}

export const SocialSignupFlow: React.FC<SocialSignupFlowProps> = ({ resourcesData, onSubmit, initialFormState }) => {
  const { showErrorBox, serverErrorMsg } = useSignInContext();
  const { formFieldsState, updateFormState } = useSocialSignupForm();
  const settings = useSelector(selectSettings);

  // Update form state when initial data is provided
  React.useEffect(() => {
    if (initialFormState) {
      updateFormState(initialFormState);
    }
  }, [initialFormState, updateFormState]);

  const handleSubmit = async (formData: any) => {
    await onSubmit({ ...initialFormState, ...formData });
  };

  return (
    <SignUpSocialMedia
      serverErrorMsg={serverErrorMsg}
      content={resourcesData}
      initialFormState={formFieldsState}
      isErrorBoxVisible={showErrorBox}
      settingData={{
        formValidations: settings.formValidations,
      }}
      onSubmit={handleSubmit}
    />
  );
};
